import { ArrayUtil, ModelRow } from "@mcleod/core";
import { ComponentFactory, DataSourceAction, DataSourceExecutionEvent } from "@mcleod/components";
import { AutogenLayoutImportDataTypeQuickInfo } from "./autogen/AutogenLayoutImportDataTypeQuickInfo";

export class ImportDataTypeQuickInfo extends AutogenLayoutImportDataTypeQuickInfo {
    sourceImportDataTypeAfterExecution(event: DataSourceExecutionEvent) {
        if (event.getAction() === DataSourceAction.SEARCH) {
            const row = ArrayUtil.getFirstElement(this.sourceImportDataType.data) as ModelRow;
            if (row != null) {
                const notes = row.get("data_type_notes") as [];
                if (!ArrayUtil.isEmptyArray(notes)) {
                    const notesLabels = ComponentFactory.createBulletedList(notes);
                    this.panelNotes.add(...notesLabels);
                    this.panelNotes.visible = true;
                    return;
                }
            }
        }
        this.panelNotes.visible = false;
    }
}
